import {hc} from 'hono/client'
import { AppType } from './api'

// websocketを利用する場合絶対パスである必要がある点に注意
export const hono_client = hc<AppType>(import.meta.env.VITE_API_URL)
